<script>
import moment from 'moment';
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import { mixin as clickaway } from 'vue-clickaway';
import { mask } from 'vue-the-mask';
import { required, email } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import BreadCrumbs from '@components/breadcrumbs/breadcrumbs-wrapper.vue';
import _ from 'lodash';
import resize from '@utils/image-sizer';
import {
  authComputed,
  authMethods,
  clientComputed,
  clientMethods,
  mediaUploadComputed,
  mediaUploadMethods,
  modalMethods,
  orgComputed,
  orgMethods
} from '@/src/state/helpers';

export default {
  data() {
    return {
      updatingprofile: false,
      uploadingImg: false,
      inputKey: 0,
      requestType: 'clients',
      type: 'cover',
      inches: 0,
      feet: 0,
      genderOptions: ['Male', 'Female', 'Not specified'],

      user: {
        email: '',
        profile: {
          firstName: '',
          lastName: '',
          phone: '',
          dob: '',
          gender: '',
          healthConditions: [],
          injuries: [],
        },
        progress: {
          initial: {
            weight: 0,
            waist: 0,
            height: 0,
            chest: 0,
            hip: 0,
          },
          goals: {
            weight: 0,
            waist: 0,
            bmi: 0,
            customGoals: [],
          },
        },
      },
    };
  },
  directives: { mask },
  validations: {
    user: {
      email: {
        required,
        email,
      },
      profile: {
        firstName: {
          required,
          isPlaceholder(value) {
            return this.isPlaceholder(value);
          },
        },
        lastName: {
          required,
          isPlaceholder(value) {
            return this.isPlaceholder(value);
          },
        },
        phone: {
          isPhone(value) {
            if (value) {
              return /^(?=(?:^(?:\+?1\s*(?:[.-]\s*)?)?(?!(?:(?:.*\(.*)|(?:.*\).*)))(?:[2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|(?:.*\((?:[2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\).*))(?:\+?1\s*(?:[.-]\s*)?)?(?:\(?([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\)?)\s*(?:[.-]\s*)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d{1,15}))?$/.test(
                value
              ); // phone valid
            } else return true;
          },
        },
        dob: {
          isDateInFuture(value) {
            const dateISO = moment(value).toISOString();
            const is13ISO = moment().toISOString();

            const date = moment(dateISO);
            const is13 = moment(is13ISO).subtract(13, 'years');

            if (value === null || value === '' || (date && value && date.isBefore(is13))) {
              return true;
            } else {
              return false;
            }
          },
        },
      },
    },
  },
  props: {
    hideRouterView: {
      type: Boolean,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [breakpointsMixin, clickaway],
  components: {
    BreadCrumbs,
    'v-select': vSelect,
  },
  mounted() {
    this.initalizeLocalState();
  },
  computed: {
    ...authComputed,
    ...clientComputed,
    ...mediaUploadComputed,
    ...orgComputed,
    colors() {
      return {
        '--color':  this.primaryColor
      }
    },
    userAvatar() {
      return this.userProfile &&
        this.userProfile.mediaAssets &&
        this.userProfile.mediaAssets.avatarImage &&
        this.userProfile.mediaAssets.avatarImage.url
        ? resize(this.userProfile.mediaAssets.avatarImage.url, 60, 60)
        : require('@assets/images/placeholder-avatar.png');
    },
    firstName() {
      return this.userProfile && this.userProfile.firstName;
    },
    lastName() {
      return this.userProfile && this.userProfile.lastName;
    },
    userName() {
      return `${this.firstName} ${this.lastName}`;
    },
    joinedOn() {
      return this.currentUser && this.currentUser.user && this.currentUser.user.joined_on
        ? moment(this.currentUser.user.joined_on).format('MMMM YYYY')
        : moment().format('MMMMM YYYY');
    },
    dob() {
      if (this.userProfile && this.userProfile.dob) {
        return moment.utc(this.userProfile.dob).format('MM/DD/YYYY');
      }
      return '';
    },
    healthConditions() {
      return this.user.profile.healthConditions.length > 0 ? this.user.profile.healthConditions.join(', ') : null;
    },
    injuries() {
      return this.user.profile.injuries.length > 0 ? this.user.profile.injuries.join(', ') : null;
    },
    customGoals() {
      const customGoals = _.cloneDeep(this.user.progress.goals.customGoals);
      if (customGoals.length > 0) {
        if (customGoals[0] === 'null') {
          customGoals.shift();
          if (customGoals.length > 0) {
            return customGoals.join(', ');
          } else {
            return '';
          }
        } else {
          return customGoals.join(', ');
        }
      } else {
        return '';
      }
    },
    heightInFeet() {
      return this.userProgress && this.userProgress.initial.height.value && this.userProgress.initial.height.isImperial
        ? this.userProgress.initial.height.value >= 12
          ? Math.floor(this.userProgress.initial.height.value / 12)
          : 0
        : null;
    },
    heightInInches() {
      return this.userProgress && this.userProgress.initial.height.value && this.userProgress.initial.height.isImperial
        ? this.userProgress.initial.height.value >= 12
          ? this.userProgress.initial.height.value - this.heightInFeet * 12
          : this.userProgress.initial.height.value
        : null;
    },
    heightMobileView() {
      return `${this.heightInFeet}' ${this.heightInInches}"`;
    },
  },
  methods: {
    ...clientMethods,
    ...mediaUploadMethods,
    ...authMethods,
    ...modalMethods,
    ...orgMethods,
    initalizeLocalState() {
      this.user.email = this.currentUser.user.email;

      this.user.profile.firstName = this.userProfile.firstName;
      this.user.profile.lastName = this.userProfile.lastName;
      this.user.profile.dob = this.userProfile.dob;
      this.user.profile.gender = this.userProfile.gender;
      this.user.profile.phone = this.userProfile.phone;
      this.user.profile.healthConditions = this.userProfile.healthConditions;
      this.user.profile.injuries = this.userProfile.injuries;

      this.user.progress.initial.weight = this.userProgress.initial.weight.value;
      this.user.progress.initial.waist = this.userProgress.initial.waist.value;
      this.user.progress.initial.height = this.userProgress.initial.height.value;
      this.user.progress.initial.chest = this.userProgress.initial.chest.value;
      this.user.progress.initial.hip = this.userProgress.initial.hip.value;

      this.user.progress.goals.weight = this.userProgress.goals.weight.value;
      this.user.progress.goals.waist = this.userProgress.goals.waist.value;
      this.user.progress.goals.bmi = this.userProgress.goals.bmi.value;
      this.user.progress.goals.customGoals = this.userProgress.goals.customGoals;

      this.inches = this.heightInInches;
      this.feet = this.heightInFeet;
    },
    async openModal(id, label) {
      await this.setInputModalLabel(label);
      this.$bvModal.show(id);
    },
    setDob(event) {
      this.$v.user.profile.dob.$touch();
      if (event) {
        this.user.profile.dob = moment(event).toISOString();
      }
    },
    calculateBmi(weight, height) {
      if (height && weight) {
        const value = (weight / height / height) * 703;
        return isNaN(value) ? 0 : value.toFixed(2);
      } else {
        return 0;
      }
    },
    isPlaceholder(value) {
      const options = ['firstname', 'lastname'];
      if (
        options.includes(
          value
            .toLowerCase()
            .replace(/ +/g, '')
            .trim()
        )
      ) {
        return false;
      } else return true;
    },
    newPhotoUrl(type, requestType) {
      return this.hasNewMedia(type, requestType)
        ? this.hasNewMedia(type, requestType).publicUrl
        : this.userProfile.mediaAssets.avatarImage.url;
    },
    imageUploadPayload() {
      const newPhotoUrl = this.newPhotoUrl(this.type, this.requestType);
      const payload = {
        client: {
          profile: {
            ...this.userProfile,
            mediaAssets: {
              avatarImage: {
                url: newPhotoUrl,
              },
            },
          },
        },
      };
      return payload;
    },
    profileUpdatePayload() {
      const heightInInches = this.calculateHeightInInches();
      const payload = {
        client: {
          email: this.user.email,
          profile: {
            ...this.userProfile,
            firstName: this.user.profile.firstName,
            lastName: this.user.profile.lastName,
            phone: this.user.profile.phone,
            dob: this.user.profile.dob,
            gender: this.user.profile.gender,
            healthConditions: this.user.profile.healthConditions,
            injuries: this.user.profile.injuries,
          },
          progress: {
            ...this.userProgress,
            initial: {
              ...this.userProgress.initial,
              weight: {
                ...this.userProgress.initial.weight,
                value: this.user.progress.initial.weight,
              },
              waist: {
                ...this.userProgress.initial.waist,
                value: this.user.progress.initial.waist,
              },
              height: {
                ...this.userProgress.initial.height,
                value: heightInInches,
              },
              chest: {
                ...this.userProgress.initial.chest,
                value: this.user.progress.initial.chest,
              },
              hip: {
                ...this.userProgress.initial.hip,
                value: this.user.progress.initial.hip,
              },
            },
            goals: {
              ...this.userProgress.goals,
              weight: {
                ...this.userProgress.goals.weight,
                value: this.user.progress.goals.weight,
              },
              waist: {
                ...this.userProgress.goals.waist,
                value: this.user.progress.goals.waist,
              },
              bmi: {
                ...this.userProgress.goals.bmi,
                value: this.user.progress.goals.bmi,
              },
              customGoals: this.user.progress.goals.customGoals,
            },
          },
        },
      };
      return payload;
    },
    updateUserName(value) {
      const splitFirstAndLastName = value.split(' ');
      this.user.profile.firstName = splitFirstAndLastName[0];
      this.user.profile.lastName = splitFirstAndLastName[1];
    },
    updateHealthConditions(value) {
      if (value === '') {
        this.user.profile.healthConditions = [];
        return;
      }

      // multiple enteries separated by commas
      const arrayOfUpdatedEnteries = value.split(', ');
      this.user.profile.healthConditions = [...new Set(arrayOfUpdatedEnteries)];
    },
    updateInjuries(value) {
      if (value === '') {
        this.user.profile.injuries = [];
        return;
      }
      // multiple enteries separated by commas
      const arrayOfUpdatedEnteries = value.split(', ');
      this.user.profile.injuries = [...new Set(arrayOfUpdatedEnteries)];
    },
    updateCustomGoals(value) {
      if (value === '') {
        this.user.progress.goals.customGoals = [];
        return;
      }
      // multiple enteries separated by commas
      const arrayOfUpdatedEnteries = value.split(', ');
      this.user.progress.goals.customGoals = [...new Set(arrayOfUpdatedEnteries)];
    },
    updateHeightFeet(value) {
      this.feet = value === '' ? null : parseInt(value);
    },
    updateHeightInches(value) {
      this.inches = value === '' ? null : parseInt(value);
    },
    calculateHeightInInches() {
      return this.inches && this.feet
        ? parseInt(this.inches) + parseInt(this.feet) * 12
        : this.feet
        ? parseInt(this.feet) * 12
        : this.inches
        ? this.inches
        : null;
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    async uploadImg(e) {
      this.uploadingImg = true;

      const file = e.target.files[0];

      await this.getS3UploadUrl({
        file,
        requestType: this.requestType,
        type: this.type,
        orgId: this.orgId,
        trainerId: this.trainerId,
      }).catch((e) => console.error(e));

      await this.uploadPhoto({ model: this.requestType, option: this.type });
      const payload = _.cloneDeep(this.imageUploadPayload());
      const response = await this.updateClient({
        clientId: this.clientId,
        trainerId: this.trainerId,
        payload,
      });
      if (response.success === false) {
        console.error('response', response);
      } else {
        const updatedUser = _.cloneDeep(this.currentUser);
        updatedUser.user = response.client;
        this.setCurrentUser(updatedUser);
      }
      // clear the image file entery from the state after it has been uploaded
      this.setSignedPostData();
      this.inputKey++;
      this.uploadingImg = false;
    },
    async updateProfileInfo() {
      this.updatingprofile = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = _.cloneDeep(this.profileUpdatePayload());
        const response = await this.updateClient({
          payload,
          clientId: this.clientId,
          trainerId: this.trainerId,
        });
        if (response.success === false) {
          console.error('response', response);
        } else {
          const updatedUser = _.cloneDeep(this.currentUser);
          updatedUser.user = response.client;
          this.setCurrentUser(updatedUser);
        }
      }
      this.updatingprofile = false;
    },
  },
};
</script>

<template>
  <div class="info-container">
    <BreadCrumbs class="second" v-if="!hideRouterView && isMobile" @back="$emit('hide-router-view')" prevPageName="profile" />
    <div>
      <div class="row avatar-container" v-if="!isMobile">
        <div class="col user-avatar">
          <span class="image-wrapper"><img :src="userAvatar" class="avatar"/></span>
          <div>
            <span class="name" :style="colors">{{ userName }}</span>
            <span class="date">Member Since {{ joinedOn }}</span>
          </div>
        </div>
        <BaseButton type="button" class="button btn-secondary" @click="onPickFile">
          <b-spinner v-show="uploadingImg" small type="grow"></b-spinner>
          <span v-show="!uploadingImg">Upload Profile Photo</span>
        </BaseButton>
        <input
          :key="inputKey"
          type="file"
          name="uploadfile"
          ref="fileInput"
          :style="{ display: 'none' }"
          accept="image/x-png,image/gif,image/jpeg,image/png"
          @change.prevent="uploadImg($event)"
        />
      </div>
    </div>
    <b-form @submit.prevent="updateProfileInfo" v-if="!isMobile" class="form-submit-test">
      <div>
        <b-row>
          <b-col>
            <b-form-group id="firstName-form" label="First Name" label-for="firstName" description="" class="form-input">
              <b-form-input
                id="firstName"
                type="text"
                placeholder="Jean"
                v-model.lazy="$v.user.profile.firstName.$model"
                :state="!$v.user.profile.firstName.$error"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ !$v.user.profile.firstName.required ? 'First Name required' : 'Enter your name' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="lastName-form" label="Last Name" label-for="lastName" description="" class="form-input">
              <b-form-input
                id="lastName"
                type="text"
                placeholder="Picard"
                v-model.lazy="$v.user.profile.lastName.$model"
                :state="!$v.user.profile.lastName.$error"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ !$v.user.profile.lastName.required ? 'Last Name required' : 'Enter your name' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="email-form" label="Email" label-for="email" description="" class="form-input">
              <b-form-input
                id="email"
                type="email"
                placeholder="jeanpicard@gmail.com"
                v-model.lazy="$v.user.email.$model"
                :state="!$v.user.email.$error"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ !$v.user.email.required ? 'Email Required' : 'Enter a valid email' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="phone-form" label="Phone" label-for="phone" description="" class="form-input">
              <b-form-input
                id="phone"
                type="text"
                placeholder="(000) 000-0000"
                v-mask="'(###) ###-####'"
                v-model.lazy="$v.user.profile.phone.$model"
                :state="!$v.user.profile.phone.$error"
              ></b-form-input>
              <b-form-invalid-feedback>
                Enter a valid phone number
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div class="personal-info-section">
        <b-row class="span-title">
          <span class="title">Personal Information</span>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="dob-form" label="Date of Birth" label-for="dob" description="" class="form-input">
              <b-form-input
                id="dob"
                placeholder="mm/dd/yyyy"
                v-mask="'##/##/####'"
                :value="dob"
                @change="setDob"
                :state="!$v.user.profile.dob.$error"
              >
              </b-form-input>
              <b-form-invalid-feedback>
                Must be 13 or older
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col class="gender-select">
            <label>Gender</label>
            <v-select
              name="gender"
              placeholder="Choose gender"
              :options="genderOptions"
              :searchable="false"
              :clearable="false"
              v-model="user.profile.gender"
            />
          </b-col>
          <b-col cols="6">
            <b-form-group id="injuries-form" label="Injuries" label-for="injuries" description="" class="form-input">
              <b-form-input
                id="injuries"
                type="text"
                placeholder="Add Injuries"
                :value="injuries"
                @change="updateInjuries($event)"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group
              id="healthConditions-form"
              label="Health Conditions"
              label-for="healthConditions"
              description=""
              class="form-input"
            >
              <b-form-input
                id="healthConditions"
                type="text"
                placeholder="Add Health Conditions"
                :value="healthConditions"
                @change="updateHealthConditions($event)"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="weight-form" label="Weight" label-for="weight" description="" class="form-input">
              <b-form-input
                id="weight"
                type="number"
                min="0"
                placeholder="0 lbs"
                v-model="user.progress.initial.weight"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <label for="height" class="height-label">Height</label>
            <b-row>
              <b-col cols="5">
                <b-form-group id="height-form" label="" description="" class="form-input">
                  <b-form-input
                    id="height-feet"
                    type="number"
                    min="0"
                    placeholder="ft"
                    :value="heightInFeet"
                    @change="updateHeightFeet($event)"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group id="height-form" label="" description="" class="form-input">
                  <b-form-input
                    id="height-inches"
                    type="number"
                    min="0"
                    max="11"
                    placeholder="in"
                    :value="heightInInches"
                    @change="updateHeightInches($event)"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <b-form-group id="chest-form" label="Chest" label-for="chest" description="" class="form-input">
              <b-form-input
                id="chest"
                type="number"
                min="0"
                placeholder="Chest (in)"
                v-model="user.progress.initial.chest"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group id="hip-form" label="Hip" label-for="hip" description="" class="form-input">
              <b-form-input
                id="hip"
                type="number"
                min="0"
                placeholder="Hip (in)"
                v-model="user.progress.initial.hip"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group id="waist-form" label="Waist" label-for="waist" description="" class="form-input">
              <b-form-input
                id="waist"
                type="number"
                min="0"
                placeholder="Waist (in)"
                v-model="user.progress.initial.waist"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div class="goals-section">
        <b-row class="span-title">
          <span class="title">Goals</span>
        </b-row>
        <b-row>
          <b-col cols="3">
            <b-form-group id="weight-goal-form" label="Goal Weight" label-for="weight-goal" description="" class="form-input">
              <b-form-input
                id="weight-goal"
                type="number"
                placeholder="0 lbs"
                v-model="user.progress.goals.weight"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group id="waist-goal-form" label="Goal Waist Size" label-for="waist-goal" description="" class="form-input">
              <b-form-input
                id="waist-goal"
                type="number"
                placeholder="Waist (in)"
                v-model="user.progress.goals.waist"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="goalBmi">
              <label>Goal BMI</label>
              <p>{{
                (user.progress.goals.weight && inches !== 0) || feet !== 0
                  ? calculateBmi(user.progress.goals.weight, inches + feet * 12)
                  : 0
              }}</p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="custom-goals-form" label="Your Goal" label-for="custom-goals" description="" class="form-input">
              <b-form-input
                id="custom-goals"
                type="text"
                placeholder="Add custom goals"
                :value="customGoals"
                @change="updateCustomGoals($event)"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <BaseButton type="submit" :disabled="updatingprofile" class="button btn-primary submit">
        <b-spinner v-show="updatingprofile" small type="grow"></b-spinner>
        <span v-show="!updatingprofile">Update Profile Info</span>
      </BaseButton>
    </b-form>
    <div v-if="isMobile" class="mobile-view">
      <div class="col option" @click.stop="openModal('name-input-modal', 'Name')">
        <span class="info-label">Name</span>
        <div class="detail">
          <span class="add-detail" v-if="!userName">Add Name</span>
          <span class="info-detail truncate">{{ userName }}</span>
          <BaseIcon class="icon-arrow" name="chevron-right" />
        </div>
      </div>
      <div class="col option" @click.stop="openModal('email-input-modal', 'Email')">
        <span class="info-label">Email</span>
        <div class="detail">
          <span class="add-detail" v-if="!user.email">Add Email</span>
          <span class="info-detail truncate">{{ currentUser.user.email }}</span>
          <BaseIcon class="icon-arrow" name="chevron-right" />
        </div>
      </div>
      <div class="col option" @click.stop="openModal('height-input-modal', 'Height')">
        <span class="info-label">Height</span>
        <div class="detail">
          <span class="add-detail" v-if="!user.progress.initial.height">Add Height</span>
          <span class="info-detail" v-if="user.progress.initial.height">{{ heightMobileView }}</span>
          <BaseIcon class="icon-arrow" name="chevron-right" />
        </div>
      </div>
      <div class="col option" @click.stop="openModal('weight-input-modal', 'Current Weight')">
        <span class="info-label">Current Weight</span>
        <div class="detail">
          <span class="add-detail" v-if="!user.progress.initial.weight">Add Weight</span>
          <span class="info-detail" v-if="user.progress.initial.weight">{{ userProgress.initial.weight.value }}</span>
          <BaseIcon class="icon-arrow" name="chevron-right" />
        </div>
      </div>
      <div class="col option" @click.stop="openModal('weight-input-modal', 'Goal Weight')">
        <span class="info-label">Goal Weight</span>
        <div class="detail">
          <span class="add-detail" v-if="!user.progress.goals.weight">Add Weight</span>
          <span class="info-detail" v-if="user.progress.goals.weight">{{ userProgress.goals.weight.value }}</span>
          <BaseIcon class="icon-arrow" name="chevron-right" />
        </div>
      </div>
      <div class="col option" @click.stop="openModal('birthday-input-modal', 'Birthday')">
        <span class="info-label">Birthday</span>
        <div>
          <span class="add-detail" v-if="!user.profile.dob">Add Birthday</span>
          <span class="info-detail">{{ dob }}</span>
          <BaseIcon class="icon-arrow" name="chevron-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable no-descending-specificity
.info-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 85vh;
  overflow: auto;
  padding: 3rem 4.5%;
  width: 100%;
  .breadcrumb-wrapper {
    margin-bottom: 0;
    padding: 0 2rem;
  }
  .personal-info-section,
  .goals-section {
    margin-top: 5rem;
  }
  .avatar-container {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-bottom: 3rem;
    .btn-secondary {
      // border: 2px solid $color-action;
      // color: $color-action;
      font-family: $base-font-family;
      font-size: 1.4rem;
      font-style: normal;
      font-weight: 800;
      line-height: 22px;
      padding: 1rem 3rem;
      &:hover {
        // background-color: $color-action;
        color: white;
      }
    }
    .user-avatar {
      align-items: center;
      display: flex;
      justify-content: flex-start;
      max-width: 70%;
      padding-left: unset;
      padding-right: unset;
      div {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-left: 1rem;
      }
      .image-wrapper {
        height: 6.3rem;
        width: 6.3rem;
        // cursor: pointer;
        img {
          border-radius: 50%;
          height: 6.3rem;
          object-fit: cover;
          width: 6.3rem;
          // cursor: pointer;
        }
        // &:hover {
        //   &::after {
        //     content: '';
        //     position: absolute;
        //     width: 3.5rem;
        //     height: 3.5rem;
        //     border-radius: 50%;
        //     // top: 4px;
        //     left: 0;
        //     right: 0;
        //     background-image: linear-gradient(rgba(black, 0.1), rgba(black, 0.1));
        //     z-index: 1;
        //   }
        // }
      }
      .name {
        color: var(--color);
        font-family: $base-font-family;
        font-size: 25px;
        font-style: normal;
        font-weight: 800;
        letter-spacing: -0.761905px;
        line-height: 25px;
        text-transform: capitalize;
      }
      .date {
        color: rgba(0, 0, 0, 0.49);
        font-size: 15px;
        font-style: normal;
        font-weight: normal;
        line-height: 18px;
        text-transform: capitalize;
      }
    }
  }
  .col,
  .col-3,
  .col-6 {
    margin-bottom: 1rem;
    padding-left: 5px;
    padding-right: 5px;
  }
  .col-5 {
    padding-right: 0;
  }
  .height-label {
    color: #000;
    font-family: $proxima-nova;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.1px;
    line-height: 22px;
    margin-bottom: 0;
    text-transform: capitalize;
  }
  .span-title {
    margin-bottom: 2rem;
    .title {
      color: #000;
      font-family: $base-font-family;
      font-size: 18px;
      font-style: normal;
      font-weight: bold;
      line-height: 25px;
      text-transform: capitalize;
    }
  }
  .btn-primary {
    background-color: black;
    border: 2px solid black;
    border-radius: 25px;
    color: white;
    font-family: $base-font-family;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 800;
    line-height: 22px;
    margin-top: 3rem;
    padding: 1rem 3rem;
    &:hover {
      background-color: white;
      color: black;
    }
  }

  .goalBmi {
    label {
      font-size: 12px;
    }
    p {
      font-size: 25px;
    }
  }
  .gender-select {
    color: #000;
    font-family: $proxima-nova;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.1px;
    line-height: 22px;
    margin-bottom: 0;
    text-transform: capitalize;
    label {
      margin-bottom: 0;
    }
  }
  .mobile-view {
    padding: 2rem;
    .option {
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
      display: flex;
      font-style: normal;
      font-weight: normal;
      justify-content: space-between;
      overflow: hidden;
      padding: 2rem 0;
      position: relative;
      transition: 0.5s all linear;
      white-space: nowrap;
      .info-label {
        color: #333;
        font-family: $base-font-family;
        font-size: 18px;
        font-weight: bold;
        line-height: 25px;
        text-transform: capitalize;
      }
      .detail {
        align-items: center;
        display: flex;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info-detail {
        color: #000;
        font-family: $proxima-nova;
        font-size: 17px;
        line-height: 21px;
        mix-blend-mode: normal;
        opacity: 0.5;
        text-align: right;
        &.truncate {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .add-detail {
        color: #4059e1;
        font-family: $proxima-nova;
        font-size: 13px;
        font-weight: 600;
        line-height: 13px;
        text-align: right;
      }

      svg {
        color: #000;
        font-size: 14px;
        line-height: 17px;
        margin-left: 3rem;
        mix-blend-mode: normal;
        opacity: 0.5;
        text-align: right;
      }
    }
  }
}

input {
  background-color: #f3f3f3;
  border: unset;
  border-radius: 8px;
  color: #000;
  font-family: $proxima-nova;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: 23px;
  mix-blend-mode: normal;
  opacity: 0.8;
  padding: 2.5rem;
  transition: 0.3s all ease-in-out;
  &:focus {
    // border: 1px $color-profile-primary-rgba solid;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 5px $color-profile-primary-rgba;
  }
  &:disabled {
    background-color: white;
  }
}
textarea:hover,
input:hover,
textarea:active,
input:active,
textarea:focus,
input:focus,
button:focus,
button:active,
button:hover,
label:focus,
.btn:active,
.btn.active {
  -webkit-appearance: none;
  outline: 0 !important;
}

.is-valid {
  background-image: none;
  &:focus {
    // border: 1px $color-profile-primary-rgba solid;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 5px $color-profile-primary-rgba;
  }
}
::v-deep {
  .d-block {
    color: #000;
    font-family: $proxima-nova;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.1px;
    line-height: 22px;
    margin-bottom: 0;
    text-transform: capitalize;
  }
  .v-select > .vs__dropdown-toggle {
    background-color: #f3f3f3;
    border-radius: 0.8rem;
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 0;
    .vs__selected-options {
      color: #000;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      font-size: 16px;
      font-style: normal;
      font-weight: normal;
      line-height: 23px;
      mix-blend-mode: normal;
      opacity: 0.9;
      padding: 7px 2px;
      transition: 0.3s all ease-in-out;
      span {
        white-space: nowrap;
      }
    }
  }
  .v-select > .vs__dropdown-menu {
    background-color: #f3f3f3;
  }
}
</style>
